import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { IDatosClienteClaveTemporal } from 'src/app/shared/Entities/firmaElectronica';
import { paths } from '../../shared/helpers/constants';
import { getErrorMessage } from '../../shared/helpers/validationMessages';
import { PersonService } from '../../shared/services/person.service';
import {
  ICiudad,
  IComuna,
  IMenuItem,
  IRegion,
} from './../../shared/Entities/entities';
import { EventsService } from './../../shared/services/events.service';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-clave-temporal',
  templateUrl: './clave-temporal.component.html',
  styleUrls: ['./clave-temporal.component.scss'],
})
export class ClaveTemporalComponent implements OnInit, OnDestroy {
  menuItems: IMenuItem[] = [
    {
      route: paths.claveTemporal,
      active: true,
      children: [{ label: 'CAMBIAR CONTRASEÑA', active: true }],
    },
  ];
  firmaDigitalState: string;

  error = false;
  editMode = false;
  datoContratante: IDatosClienteClaveTemporal;
  form: FormGroup;
  regiones: IRegion[] = [];
  comunas: IComuna[] = [];
  ciudades: ICiudad[] = [];
  getErrorMessage = getErrorMessage;

  private subscriptions: Subscription[] = [];

  firmaVisible = false;
  srcPDF: string;

  constructor(
    private eventsSrv: EventsService,
    public modal: MatDialog,
    private personService: PersonService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog
  ) {}
  get claveOriginal() {
    return this.form.get('claveOriginal');
  }
  get claveNueva() {
    return this.form.get('claveNueva');
  }
  get claveNuevaReingresada() {
    return this.form.get('claveNuevaReingresada');
  }

  ngOnInit() {
    this.eventsSrv.setMenu(this.menuItems);
    this.inicializar();
  }

  inicializar() {
    this.form = this.formBuilder.group({
      claveOriginal: [null, [Validators.required]],
      claveNueva: [null, [Validators.required]],
      claveNuevaReingresada: [null, [Validators.required]],
    });
  }

  guardar() {
    this.error = false;
    if (!this.form.valid || !this.form.dirty) {
      return;
    }
    if (
      this.form.get('claveNueva').value !==
      this.form.get('claveNuevaReingresada').value
    ) {
      this.form.controls['claveNuevaReingresada'].setErrors({
        mismatchPass: true,
      });
    } else {
      this.personService.postChangePass(this.form.value).subscribe(
        res => {
          localStorage.setItem('claveTemporal', '1');
          this.showModal();
          this.resetForm();
        },
        err => (this.error = true)
      );
    }
  }

  showModal() {
    // cerar modal
    this.dialog.open(ConfirmModalComponent, {
      width: '290px',
      height: '180px',
      disableClose: true,
      closeOnNavigation: true,
    });
  }

  resetForm() {
    this.form.reset();
    this.form.markAsPristine();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
